/* Silent looping clips: load only near the viewport, never when the visitor prefers reduced motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var videos = document.querySelectorAll('[data-ap-video] video[data-src]');
  if (!videos.length) return;
  var start = function (v) {
    if (v.src) return;
    v.src = v.dataset.src;
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };
  if (!('IntersectionObserver' in window)) { videos.forEach(start); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { start(e.target); if (e.target.paused) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } }
      else if (e.target.src) { e.target.pause(); }
    });
  }, { rootMargin: '200px 0px' });
  videos.forEach(function (v) { io.observe(v); });
})();
